 $("#arrowUp").click(function(){
    $('html').scrollTop(0).attr("style", "scroll-behavior: smooth;");
  });
  
  
  $(document).scroll(function() {
    var scrollTop = $(window).scrollTop();
    if(scrollTop > 20){
      $("#arrowUp").attr("style","display: flex; scroll-behavior: smooth;");
    }else{
      $("#arrowUp").attr("style","display: none;");
    }
  });